import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=b7ebaed4&scoped=true&"
import script from "./SideModal.vue?vue&type=script&lang=ts&"
export * from "./SideModal.vue?vue&type=script&lang=ts&"
import style0 from "./SideModal.vue?vue&type=style&index=0&id=b7ebaed4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ebaed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7ebaed4')) {
      api.createRecord('b7ebaed4', component.options)
    } else {
      api.reload('b7ebaed4', component.options)
    }
    module.hot.accept("./SideModal.vue?vue&type=template&id=b7ebaed4&scoped=true&", function () {
      api.rerender('b7ebaed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SideModal.vue"
export default component.exports